export { default } from './TermsAndConditionsModal'
